/*
 * File: d:\projects\AutoFiFront\src\Utils\GetBrandToDisplay.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday March 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 13th 2023 9:17:06 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { ReactNode, useEffect, useState } from 'react';
import ABARTH from 'Content/SVG/BrandSVG/ABARTH';
import ALFA from 'Content/SVG/BrandSVG/ALFA';
import AUDI from 'Content/SVG/BrandSVG/AUDI';
import BMW from 'Content/SVG/BrandSVG/BMW';
import CITROEN from 'Content/SVG/BrandSVG/CITROEN';
import CUPRA from 'Content/SVG/BrandSVG/CUPRA';
import DACIA from 'Content/SVG/BrandSVG/DACIA';
import DS from 'Content/SVG/BrandSVG/DS';
import FIAT from 'Content/SVG/BrandSVG/FIAT';
import FORD from 'Content/SVG/BrandSVG/FORD';
import HONDA from 'Content/SVG/BrandSVG/HONDA';
import HYUNDAI from 'Content/SVG/BrandSVG/HYUNDAI';
import JAGUAR from 'Content/SVG/BrandSVG/JAGUAR';
import KIA from 'Content/SVG/BrandSVG/KIA';
import LAND_ROVER from 'Content/SVG/BrandSVG/LAND_ROVER';
import MERCEDES from 'Content/SVG/BrandSVG/MERCEDES';
import MINI from 'Content/SVG/BrandSVG/MINI';
import MITSUBISHI from 'Content/SVG/BrandSVG/MITSUBISHI';
import NISSAN from 'Content/SVG/BrandSVG/NISSAN';
import OPEL from 'Content/SVG/BrandSVG/OPEL';
import PORSCHE from 'Content/SVG/BrandSVG/PORSCHE';
import RENAULT from 'Content/SVG/BrandSVG/RENAULT';
import SEAT from 'Content/SVG/BrandSVG/SEAT';
import SKODA from 'Content/SVG/BrandSVG/SKODA';
import SUZUKI from 'Content/SVG/BrandSVG/SUZUKI';
import TOYOTA from 'Content/SVG/BrandSVG/TOYOTA';
import VOLVO from 'Content/SVG/BrandSVG/VOLVO';
import VW from 'Content/SVG/BrandSVG/VW';
import { SVGProps } from 'Content/SVG/SVGProps';
import PEUGEOT_BLANC from 'Content/SVG/BrandSVG/PEUGEOT_BLANC';

const useGetBrandToDisplay = (brand: string, props:SVGProps) => {
    const [myReactNode, setMyReactNode] = useState<ReactNode>(null);

    useEffect(() => {
        switch (brand) {
            case "abarth":
                setMyReactNode(<ABARTH fill={props.fill}/>);
                break;
            case "alfa":
                setMyReactNode(<ALFA fill={props.fill}/>);
                break;
            case "audi":
                setMyReactNode(<AUDI fill={props.fill}/>);
                break;
            case "bmw":
                setMyReactNode(<BMW fill={props.fill}/>);
                break;
            case "citroen":
                setMyReactNode(<CITROEN fill={props.fill}/>);
                break;
            case "cupra":
                setMyReactNode(<CUPRA fill={props.fill}/>);
                break;
            case "dacia":
                setMyReactNode(<DACIA fill={props.fill}/>);
                break;
            case "ds":
                setMyReactNode(<DS fill={props.fill}/>);
                break;
            case "fiat":
                setMyReactNode(<FIAT fill={props.fill}/>);
                break;
            case "ford":
                setMyReactNode(<FORD fill={props.fill}/>);
                break;
            case "honda":
                setMyReactNode(<HONDA fill={props.fill}/>);
                break;
            case "hyundai":
                setMyReactNode(<HYUNDAI fill={props.fill}/>);
                break;
            case "jaguar":
                setMyReactNode(<JAGUAR fill={props.fill} />);
                break;
            case "kia":
                setMyReactNode(<KIA fill={props.fill}/>);
                break;
            case "land-rover":
                setMyReactNode(<LAND_ROVER fill={props.fill}/>);
                break;
            case "land rover":
                setMyReactNode(<LAND_ROVER fill={props.fill}/>);
                break;
            case "mercedes":
                setMyReactNode(<MERCEDES fill={props.fill}/>);
                break;
            case "mini":
                setMyReactNode(<MINI fill={props.fill}/>);
                break;
            case "mitsubishi":
                setMyReactNode(<MITSUBISHI fill={props.fill}/>);
                break;
            case "nissan":
                setMyReactNode(<NISSAN fill={props.fill}/>);
                break;
            case "opel":
                setMyReactNode(<OPEL fill={props.fill}/>);
                break;
            case "peugeot":
                setMyReactNode(<PEUGEOT_BLANC fill={props.fill}/>);
                break;
            case "porsche":
                setMyReactNode(<PORSCHE fill={props.fill}/>);
                break;
            case "renault":
                setMyReactNode(<RENAULT fill={props.fill}/>);
                break;
            case "seat":
                setMyReactNode(<SEAT fill={props.fill}/>);
                break;
            case "mercedes":
                setMyReactNode(<MERCEDES fill={props.fill}/>);
                break;
            case "skoda":
                setMyReactNode(<SKODA fill={props.fill}/>);
                break;
            case "suzuki":
                setMyReactNode(<SUZUKI fill={props.fill}/>);
                break;
            case "toyota":
                setMyReactNode(<TOYOTA fill={props.fill}/>);
                break;
            case "volvo":
                setMyReactNode(<VOLVO fill={props.fill}/>);
                break;
            case "volkswagen":
                setMyReactNode(<VW fill={props.fill}/>);
                break;
            default:
                setMyReactNode(null);
                break;
        }
    }, [brand]);

    return myReactNode;
};

export default useGetBrandToDisplay;
